import React from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { articles } from './articles';
import styles from './styles.module.css';

const articleKeys = Object.keys(articles);

type Props = {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  articleId: string | number;
};

declare global {
  interface Window {
    Intercom?: (action: string, actionParameter?: any) => void;
    onNewIntercomMessage?: (count: number) => void;
    navbar_props: {
      isTesting: boolean;
    };
  }
}

const getArticleKey = (articleId: string | number) => {
  return articleKeys.find(
    key =>
      articles[key].elevio === Number(articleId) ||
      articles[key].intercom === Number(articleId)
  );
};

export const getGuideLink = ({
  articleKey,
  text = ''
}: {
  articleKey: string;
  text?: string;
}): {
  text: string;
  link: string;
  articleId: number;
} => {
  const { intercom, name } = articles[articleKey] || {};

  return {
    text,
    link: `/articles/${intercom}-${name}`,
    articleId: intercom
  };
};

export const onContactSupport = (event?: any) => {
  event?.preventDefault();
  if (window.Intercom) {
    window.Intercom('showSpace', 'home');
  } else {
    window.open('mailto:support@bugherd.com');
  }
};

export const subscribeToNewMessageEvent = (
  callback: (count: number) => void
) => {
  if (window.Intercom) {
    const existingHandler = window.onNewIntercomMessage;
    if (existingHandler) {
      window.onNewIntercomMessage = (count: number) => {
        existingHandler(count);
        callback(count);
      };
    } else {
      window.onNewIntercomMessage = callback;
    }

    window.Intercom('onUnreadCountChange', (count: number) => {
      if (window.onNewIntercomMessage) {
        window.onNewIntercomMessage(count);
      }
    });
  }
};

export const onArticleClick = (
  {
    articleId,
    articleKey
  }: {
    articleId: string | number;
    articleKey?: string;
  },
  event?: any
) => {
  event?.preventDefault();
  articleKey = articleKey || getArticleKey(articleId);
  if (!articleKey) return;
  const { intercom, name } = articles[articleKey] || {};

  if (!window.navbar_props?.isTesting && window.Intercom) {
    window.Intercom('showArticle', intercom);
  } else {
    window.open(
      `https://support.bugherd.com/articles/${intercom}-${name}`,
      '_blank'
    );
  }
};

const HelpArticleButton = ({ articleId, children, style = {} }: Props) => {
  const articleKey = getArticleKey(articleId);
  if (!articleKey) return null;

  return (
    <span
      className={styles.helpArticleButton}
      onClick={onArticleClick.bind(null, { articleId, articleKey })}
      style={style}
    >
      {children || <InfoCircleOutlined style={{ color: '#3F71E0' }} />}
    </span>
  );
};

export const HelpModuleButton = ({
  children
}: {
  children?: React.ReactNode;
}) => {
  return (
    <a onClick={onContactSupport}>
      {children || <InfoCircleOutlined style={{ color: '#3F71E0' }} />}
    </a>
  );
};

export default HelpArticleButton;
